import { getConfig } from "config/config";
import { SHOW_ALL_PARAM } from "config/constants";

import { ErrorData, ErrorType } from "./types";


const { REACT_APP_BASE_PREFIX } = getConfig();
const APP_URL = `${window.location.origin}${REACT_APP_BASE_PREFIX}`;

export const ERROR_TYPE_TO_DATA: Record<ErrorType, ErrorData> = {
  [ErrorType.ERROR_USER_DISABLED]: {
    title: "Sorry,",
    subtitle: "Disabled account",
    description: "The current account does not have authorized access. Please login with another account",
    redirect: {
      title: "Log out",
      link: `${REACT_APP_BASE_PREFIX}/logout`,
    },
  },
  [ErrorType.ERROR_403]: {
    title: "403",
    subtitle: "Sorry, you don't have permission",
    description: "The page you're trying access has restricted access. Please refer to your system administrator",
    redirect: {
      title: "Go back to home",
      link: REACT_APP_BASE_PREFIX,
    },
  },
  [ErrorType.ERROR_404]: {
    title: "404",
    subtitle: "Sorry, page not found!",
    description:
      "Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spelling.",
    redirect: {
      title: "Go back to home",
      link: REACT_APP_BASE_PREFIX,
    },
  },
  [ErrorType.ERROR_500]: {
    title: "500",
    subtitle: "Internal sever error",
    description: "There was an error, please try again later.",
    redirect: {
      title: "Go back to home",
      link: REACT_APP_BASE_PREFIX,
    },
  },
  [ErrorType.ERROR_RENDERING]: {
    title: "Sorry,",
    subtitle: "An error has occurred",
    description: "Please check back later.",
    redirect: {
      title: "Go back to home",
      link: REACT_APP_BASE_PREFIX,
    },
  },
  [ErrorType.LOGGED_OUT]: {
    title: "",
    subtitle: "We are logging you out...",
    description: "Please wait a second",
  },
  [ErrorType.ADMIN_DETECTOR_LIST_BLOCKED]: {
    title: "",
    subtitle: "Detector list is disabled for admin accounts",
    description:
      "To prevent accidental viewing of customer images, admin accounts can't browse the full detector list on this" +
      " deployment. To open a specific detector, go to its page directly:" +
      ` ${APP_URL}/detectors/<detector_id>`,
    redirect: {
      title: "Show anyway",
      addSearchParams: { [SHOW_ALL_PARAM]: "true" },
    },
  },
  [ErrorType.ADMIN_GLOBAL_REVIEW_BLOCKED]: {
    title: "",
    subtitle: "Global review queue is disabled for admin accounts",
    description:
      "To prevent accidental viewing of customer images, admin accounts can't use the global review queue on this" +
      " deployment. To review a specific detector, go to its review page directly:" +
      ` ${APP_URL}/review/queue?detector_id=<detector_id>&ground_truth=true`,
    redirect: {
      title: "Show anyway",
      addSearchParams: { [SHOW_ALL_PARAM]: "true" },
    },
  },
};
